import { create } from 'zustand';

/* ==========================================================================
   Desligamento em tempo de execução

   A flag diz se a loja tem o Vapt IA. Mas ela pode ser desligada no
   backoffice com a gaveta aberta, e aí a API passa a responder 404
   `vapt_ai_disabled`. Quando isso chega, o launcher some e a gaveta fecha —
   sem esperar a próxima leitura de flags.

   O estado guarda de qual estabelecimento veio a recusa. Assim trocar de
   loja volta a mostrar o launcher sem nenhum efeito de limpeza: quem
   pergunta compara com o tenant corrente.
   ========================================================================== */

interface VaptAiAvailabilityState {
  disabledTenantId: string | null;
  markDisabled: (tenantId: string) => void;
  clear: () => void;
}

export const useVaptAiAvailabilityStore = create<VaptAiAvailabilityState>((set) => ({
  disabledTenantId: null,
  markDisabled: (tenantId) => set({ disabledTenantId: tenantId }),
  clear: () => set({ disabledTenantId: null }),
}));

/** A API recusou por flag desligada para este estabelecimento. */
export function markVaptAiDisabled(tenantId: string): void {
  if (tenantId) useVaptAiAvailabilityStore.getState().markDisabled(tenantId);
}
